
const { ccclass, property } = cc._decorator;
import ViewBase from "../../../table/module/poker_table/poker_table_base_view"
import AudioManager from "../../../../manager/audio_manager";
import TimeManager from "../../../../manager/time_manager";
import BiPaiSeatCards from "./bipai_seat_cards";
import BiPaiSeatDispatchedCards from "./bipai_seat_dispathed_cards";
import BiPaiTableSeatView from "./bipai_table_seat_view";
import PromiseUtility from "../../../../utility/promiseUtility";
import Utility from "../../../../utility/utility";
import BiPaiSeatMingCards from "./bipai_seat_ming_cards";
import BiPaiSeatBombView from "./bipai_seat_bomb_view";
import BiPaiSeatGenPaiView from "./bipai_seat_genpai_view";
import GameUtil from "../../../../utility/game_util";
import PokerRecorder from "../../../table/module/poker_recorder/poker_recorder";

const const_dir_map = [
    [0, 1, 1, -1, -1],
    [-1, 0, -1, -1, -1],
    [-1, -1, 0, -1, -1],
    [1, 1, 1, 0, 1],
    [1, 1, 1, 1, 0],
]

@ccclass
export default class BiPaiTableBaseView extends ViewBase {
    
    @property(cc.Label)
    timeLabel: cc.Label = null

    @property(cc.Label)
    mySeatClockLabel: cc.Label = null

    @property(cc.Node)
    nodeMySeatClock: cc.Node = null

    @property(cc.Node)
    nodeStartAnim: cc.Node = null

    @property([BiPaiSeatCards])
    seatHandCardsList: BiPaiSeatCards[] = []

    @property([BiPaiSeatCards])
    seatMingHandCardsList: BiPaiSeatCards[] = []

    @property([cc.Node])
    seatMingHandCardsNodeList: cc.Node[] = []

    @property([BiPaiSeatDispatchedCards])
    seatDispatchCardsList: BiPaiSeatDispatchedCards[] = []

    @property(cc.Node)
    seatDispatchCardsNodeList: cc.Node[] = []

    @property([cc.Node])
    nodeGenPaiPrefabList: cc.Node[] = []

    @property([cc.Node])
    nodeGenPaiParentList: cc.Node[] = []

    @property(cc.Node)
    nodeGoldPrefab: cc.Node = null

    @property(cc.Node)
    nodeGoldParent: cc.Node = null

    @property(cc.Node)
    nodePokerHeap: cc.Node = null

    @property(cc.Label)
    labelPokerHeapCount: cc.Label = null

    @property(cc.Node)
    nodeFeiJiAnim: cc.Node = null

    @property(BiPaiSeatBombView)
    seatBombViewList: BiPaiSeatBombView[] = []

    @property(BiPaiSeatGenPaiView)
    seatGenPaiViewList: BiPaiSeatGenPaiView[] = []

    @property(PokerRecorder)
    pokerRecorder: PokerRecorder = null

    protected m_seatDispatchCardsListMap = {}
    protected m_seatRestDispatchCardsListMap = {}

    protected m_clockScheduleId: number = 0
    protected m_unuseGoldList: cc.Node[] = []

    protected m_seatMingHandCardsList: BiPaiSeatCards[] = []

    onLoad(){
        super.onLoad()
        this.setSeatCount(5)
        this.resetSeatViewPos()
        for (let index = 0; index < this.seatDispatchCardsNodeList.length; index++) {
            this.m_seatDispatchCardsListMap[index] = []
        }
    }

    protected cloneSeatDispatchCards(biPaiSeatDispatchedCards: BiPaiSeatDispatchedCards, parent: cc.Node): BiPaiSeatDispatchedCards{
        let node = biPaiSeatDispatchedCards.node
        let newNode = this.instantiateObj(node, parent)
        return newNode.getComponent(BiPaiSeatDispatchedCards)
    }

    protected cloneSeatMingHandCards(seatCards: BiPaiSeatCards, parent: cc.Node): BiPaiSeatCards{
        let node = seatCards.node
        let newNode = this.instantiateObj(node, parent)
        return newNode.getComponent(BiPaiSeatCards)
    }

    protected initSeatDispatchCards(localPos: number): BiPaiSeatDispatchedCards[]{
        let nodeParent: cc.Node = this.seatDispatchCardsNodeList[localPos]
        let prefab: BiPaiSeatDispatchedCards = null
        if(localPos == 1 || localPos == 2){
            prefab = this.seatDispatchCardsList[1]
        }else if(localPos == 3 || localPos == 4){
            prefab = this.seatDispatchCardsList[2]
        }else{
            prefab = this.seatDispatchCardsList[0]
        }
        return [this.cloneSeatDispatchCards(prefab, nodeParent), this.cloneSeatDispatchCards(prefab, nodeParent)]
    }

    protected getRestDispatchCardsList(localPos: number){
        let list = this.m_seatRestDispatchCardsListMap[localPos]
        if(!list){
            list = this.m_seatRestDispatchCardsListMap[localPos] = this.initSeatDispatchCards(localPos)
        }
        return list
    }

    protected initSeatMingHandCards(localPos: number): BiPaiSeatCards{
        let nodeParent: cc.Node = this.seatMingHandCardsNodeList[localPos]
        let prefab: BiPaiSeatCards = null
        if(localPos == 1 || localPos == 2){
            prefab = this.seatMingHandCardsList[1]
        }else if(localPos == 3 || localPos == 4){
            prefab = this.seatMingHandCardsList[2]
        }else{
            prefab = this.seatMingHandCardsList[0]
        }
        return this.cloneSeatMingHandCards(prefab, nodeParent)
    }

    protected getSeatMingHandCards(localPos: number){
        let seatCards = this.m_seatMingHandCardsList[localPos]
        if(!seatCards){
            seatCards = this.m_seatMingHandCardsList[localPos] = this.initSeatMingHandCards(localPos)
        }
        return seatCards        
    }

    setSeatCount(count) {
        super.setSeatCount(count || 5)
    }

    unscheduleAllCallbacks(){
        super.unscheduleAllCallbacks()
    }

    resetView(){
        super.resetView()

    }

    resetSeatAll(i: number){
        super.resetSeatAll(i)
        let discards1 = this.getSeatDispatchCards(i, true)
        discards1.showPokers(false)
        let discards2 = this.getSeatDispatchCards(i, false)
        discards2.showPokers(false)
        this.showSeatHandCards(i, false)
        this.showSeatKickBtn(i, false)   
        this.showSeatClock(i, false)
        this.showSeatRechargingTag(i, false)
        this.showSeatWinEffect(i, false)
        this.showSeatMingHandCardPoint(i, false, 0)
        this.showSeatMingHandCards(i, false)
        this.showOpenCardAnim(i, false)
        this.showKaiPaiLoseAnim(i, false)
        this.showWinCardPointAnim(i, false)
        this.showMingWinAnim(i, false)
        this.showSanTiaoAnim(i, false)
        this.showHuLuAnim(i, false)
        this.showTongHuaAnim(i, false)
        this.showSiTiaoAnim(i, false)
        this.showSeatScore(i, false)
        this.showSeatPiaoFen(i, false)
        this.showTongHuaShunAnim(i, false)

        this.showSanTiaoAnim(i, false)
        this.showSiTiaoAnim(i, false)
        this.showHuLuAnim(i, false)
        this.showTongHuaAnim(i, false)
        this.showTongHuaShunAnim(i, false)
        this.showHuangJiaTongHuaShunAnim(i, false)
        this.showShunZiAnim(i, false)
        this.showZiMoWenZiAnim(i, false)
        this.showJiePaoWenZiAnim(i, false)
        this.showFangPaoAnim(i, false)
    }

    resetSeatViewPos(){
        super.resetSeatViewPos()
        
    }


    getSeatIndexSequence():number[]{
        let sequence = []
        let seatCount = this.getSeatCount()
        for (let index = 0; index < seatCount; index++) {            
            sequence.push(index)
        }
        return sequence
    }

    protected calcPlayerInfoPanelPosByLocalPos(localPos: number): number{
        switch (localPos) {
            case 1:
            case 2:
                return 1;
            case 3:
                return 2;
        
            default:
                return 0
        }
    }


    refreshTime(show: boolean, date?: Date){
        if(!show){
            this.timeLabel.node.parent.active = false
            return
        }
        this.timeLabel.node.parent.active = true
        let nowDate = date? date: new Date(Date.now())
        this.timeLabel.string = nowDate.getHours() + ':' + nowDate.getMinutes()
    }

    showSeatWatchTag(localPos: number, show: boolean){
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showWatchTag(show)
    }

    showSeatRechargingTag(localPos: number, show: boolean){
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showRechargeTag(show)
    }

    showSeatWinEffect(localPos: number, show: boolean, onFinish?: Function){
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showWinEffect(show, onFinish)
    }

    showSeatHandCards(localPos: number, show: boolean, codeList?: number[], params?: any){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.showPokers(show, codeList, params)
    }

    bindSeatHandCardsUid(localPos: number, uid: number){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.uid = uid
    }

    playSeatFaPaiAnim(localPos: number, codeList: number[], duration: number, interval: number, delay: number, onFinish: Function, onStart?: Function){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.playFaPaiAnim(codeList, duration, interval, delay, onFinish, onStart)
    }

    playSeatMoPaiAnim(localPos: number, code: number, codeList: number[], duration: number, onFinish?: Function){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.playMoPaiAnim(code, codeList, duration, onFinish)
    }

    showSeatMingHandCards(localPos: number, show: boolean, codeList?: number[], params?: any){
        let seatHandCards = this.getSeatMingHandCards(localPos)
        seatHandCards.showPokers(show, codeList, params)
    }

    bindSeatMingHandCardsUid(localPos: number, uid: number){
        let seatHandCards = this.getSeatMingHandCards(localPos)
        seatHandCards.uid = uid
    }

    showSeatMingHandCardPoint(localPos: number, show: boolean, pointNum: number, isGray?: boolean){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        seatHandCards.showResult(show, pointNum, isGray)
    }

    getSeatDispatchCards(localPos: number, show: boolean): BiPaiSeatDispatchedCards{
        let list = this.m_seatDispatchCardsListMap[localPos]
        let restList = this.getRestDispatchCardsList(localPos)
        let discards
        if(show){
            if(restList.length > 0){
                discards = restList.shift()             
            }else{
                discards = list.shift()
            }
            list.push(discards)
        }else{
            if(list.length > 0){
                discards = list.shift()
            }else{
                discards = restList.shift()
            }
            restList.push(discards)
        }
        return discards
    }

    bindSeatDispatchCardsUid(localPos: number, uid: number){
        this.getSeatDispatchCards(localPos, false).uid = uid
        this.getSeatDispatchCards(localPos, false).uid = uid
    }

    setSeatDispatchCardsLastIndex(localPos: number){
        let list = this.m_seatDispatchCardsListMap[localPos]
        if(!list || list.length == 0){
            return
        }
        let seatDiscardsParentNode = list[0].node.parent
        for (let index = 0; index < seatDiscardsParentNode.parent.childrenCount; index++) {
            const element = seatDiscardsParentNode.parent.children[index];
            if(element == seatDiscardsParentNode){
                element.zIndex = seatDiscardsParentNode.parent.childrenCount
            }else{
                element.zIndex = index
            }
        }
        seatDiscardsParentNode.parent.children.sort(function(a, b){
            return a.zIndex - b.zIndex
        })
    }
    

    showSeatClock(localPos: number, show: boolean, secs?: number, needShake?: boolean, onFinish?: Function, onTick?: Function) {
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showClock(show, secs, needShake, onFinish, onTick)
    }

    protected showMyClock(show: boolean){
        this.nodeMySeatClock.active = !!show
    }

    protected refreshClockLable(secs: number, needShake?: boolean, onFinish?: Function){
        let self = this
        this.mySeatClockLabel.string = secs.toString()
        if(secs <= 0){
            if(needShake){
                AudioManager.instance.vibrate()
            }
            if(onFinish){
                onFinish()
            }
            return
        }
        this.m_clockScheduleId = TimeManager.instance.doScheduleOnce(function(){
            self.m_clockScheduleId = 0
            secs--
            self.refreshClockLable(secs, needShake, onFinish)
        }, 1)
    }
    

    playDispatchCard(localPos: number, codeList: number[], duration: number, fromWorldPos: cc.Vec2, onFinish?: Function){
        let self = this
        let seatDiscards = self.getSeatDispatchCards(localPos, true)
        seatDiscards.playDispatchAnim(codeList, duration, 0, fromWorldPos, onFinish)
        for (let index = 0; index < seatDiscards.node.parent.childrenCount; index++) {
            const node = seatDiscards.node.parent.children[index]
            if(node == seatDiscards.node){
                node.zIndex = seatDiscards.node.parent.childrenCount
            }else{
                node.zIndex = index
            }
        }
        seatDiscards.node.parent.children.sort(function(a, b){
            return a.zIndex - b.zIndex
        })
    }

    playRecycleDispatchCards(localPos: number, isAll: boolean, duration: number, interval: number, delay: number, onFinish?: Function){
        let self = this
        let do_funs = []
        let seatDiscards = self.getSeatDispatchCards(localPos, false)
        do_funs.push(function(cb){
            seatDiscards.playRecycleAnim(duration, interval, delay, cb)
        }) 
        if(isAll){
            let seatDiscards1 = self.getSeatDispatchCards(localPos, false)
            do_funs.push(function(cb){
                seatDiscards1.playRecycleAnim(duration, interval, delay, cb)
            })  
        }
        PromiseUtility.all(do_funs).then(function(){
            onFinish && onFinish()
        })
    }

    showSeatGoldAnim(localPos: number, show: boolean, delay?: number, onFinish?: Function){
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showGoldAnim(show, delay, onFinish)
    }

    showSeatDispatchCards(localPos: number, show: boolean, isAll?: boolean, codeList?: number[], params?){
        let self = this
        if(show){
            let seatDiscards = self.getSeatDispatchCards(localPos, true)
            seatDiscards.showPokers(show, codeList, params)
            for (let index = 0; index < seatDiscards.node.parent.childrenCount; index++) {
                const node = seatDiscards.node.parent.children[index]
                if(node == seatDiscards.node){
                    node.zIndex = (seatDiscards.node.parent.childrenCount+1)
                }else{
                    node.zIndex = (index + 1)
                }
            }
        }else{
            if(!isAll){
                let seatDiscards = self.getSeatDispatchCards(localPos, false)
                seatDiscards.showPokers(show)
            }else{
                self.getSeatDispatchCards(localPos, false).showPokers(false)
                self.getSeatDispatchCards(localPos, false).showPokers(false)
            }
        }
    }

    protected getAvailableGold(){
        if(this.m_unuseGoldList.length > 0){
            return this.m_unuseGoldList.pop()
        }
        let node = this.instantiateObj(this.nodeGoldPrefab, this.nodeGoldPrefab.parent)
        return node
    }

    protected recycleGoldNode(node: cc.Node){
        this.m_unuseGoldList.push(node)
        node.parent = this.nodeGoldPrefab.parent
        node.position = cc.Vec2.ZERO        
        node.active = false
    }

    protected playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: number, targetAngle: number, duration: number, delay?: number, onFinish?: Function, easingType?){
        let self = this
        let do_fun = function(){
            let moveAnim = null
            if(targetPos != null){
                moveAnim = cc.moveTo(duration, targetPos)       
            }
            let rotaAnim = null
            if(targetScale != null){
                rotaAnim = cc.rotateTo(duration, targetAngle)
            }     
            let scaleAnim = null
            if(targetAngle != null){
                scaleAnim = cc.scaleTo(duration, targetScale)
            }
            
            if(easingType){
                moveAnim && (moveAnim = moveAnim.easing(easingType))
                rotaAnim && (rotaAnim = rotaAnim.easing(easingType))
                scaleAnim && (scaleAnim = scaleAnim.easing(easingType))
            }
            let callFun = cc.callFunc(function(){
                onFinish && onFinish()
            }.bind(self))
            let list = []
            if(moveAnim){
                list.push(moveAnim)
            }
            if(rotaAnim){
                list.push(rotaAnim)
            }
            if(scaleAnim){
                list.push(scaleAnim)
            }
            let swap
            if(list.length == 1){
                swap = list[0]
            }else{
                swap = cc.spawn(list)
            }
             
            var seq = cc.sequence([swap, callFun])
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    playGoldFlyAnim(fromPos: number, toPos: number, duration: number, onFinish?: Function, count?: number, interval?: number, delay?: number){
        let self = this
        let seatCount = self.getSeatCount()        
        for (let index = 0; index < seatCount; index++) {
            let seatView = self.getSeatViewByPos(index) as BiPaiTableSeatView
            if(index == fromPos){
                seatView.node.parent.zIndex = seatCount
            }else{
                seatView.node.parent.zIndex = index
            }        
        }
        count = count || 5
        delay = delay || 0
        let fromSeatView = self.getSeatViewByPos(fromPos) as BiPaiTableSeatView
        let toSeatView = self.getSeatViewByPos(toPos) as BiPaiTableSeatView
        let do_funs = []
        for (let index = 0; index < count; index++) {
            let gold = self.getAvailableGold()            
            let offset = Utility.randomInsideRadius(fromSeatView.maxGoldPosRadius)            
            let fromWorldPos = fromSeatView.nodeGoldParent.convertToWorldSpaceAR(offset)
            let targetWorldPos = toSeatView.nodeGoldParent.convertToWorldSpaceAR(offset)
            let fromLocalPos = self.nodeGoldParent.convertToNodeSpaceAR(fromWorldPos)
            let targetLocalPos = self.nodeGoldParent.convertToNodeSpaceAR(targetWorldPos)
            gold.parent = self.nodeGoldParent
            gold.active = true
            gold.position = fromLocalPos
            interval = interval || 0.1
            let singleDelay = Utility.random(0.01, interval)
            let tmp_fun = function(cb){
                self.playFadeAnim(gold, 0, 255, duration * 0.1, delay + singleDelay * index)
                self.playNodeAnim(gold, targetLocalPos, null, null, duration, delay + singleDelay * index, function(){
                    self.recycleGoldNode(gold)
                    cb && cb()
                })
            }
            do_funs.push(tmp_fun)
        }
        PromiseUtility.all(do_funs).then(function(){
            onFinish && onFinish()
        })
    }

    playStartRoundAnim(onFinish: Function){
        let self = this
        self.nodeStartAnim.active = true
        self.scheduleOnce(function(){
            self.nodeStartAnim.active = false
            onFinish && onFinish()
        }, 1.5)
    }

    showPokerHeap(show: boolean, leftCount?: number){
        this.nodePokerHeap.active = !!show
        if(show){
            this.labelPokerHeapCount.string = leftCount + ''
        }        
    }

    showOpenCardAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards            
        if(show){
            let node = this.instantiateObj(seatHandCards.nodeOpenCardAnimPrefab, seatHandCards.nodeOpenCardAnimParent)
            node.position = cc.Vec2.ZERO
            node.active = true            
            this.scheduleOnce(function(){
                node.destroy()
                onFinish && onFinish()
            }, 1.5)
        }
    }

    showKaiPaiLoseAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let node = seatHandCards.nodeKaiPaiLoseAnim
        node.active = !!show
        if(show){
            this.scheduleOnce(function(){
                node.active = false
                onFinish && onFinish()
            }, 0.6)
        }
    }

    //赢得盾动画
    showWinCardPointAnim(localPos: number, show: boolean, pointNum?: number, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let node = seatHandCards.nodeResultWinAnim
        node.active = !!show
        if(show){
            seatHandCards.labelWinAnimResult.string = pointNum + ''
        }
        this.scheduleOnce(function(){
            onFinish && onFinish()
        }, 0.5)
    }

    showMingWinAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        seatHandCards.showWinAnim(show, onFinish)
    }

    showSanTiaoAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playSanTiaoAnim(show, onFinish)
    }

    showShunZiAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playShunZiAnim(show, onFinish)
    }

    showHuLuAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playHuLuAnim(show, onFinish)
    }

    showTongHuaAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playTongHuaAnim(show, onFinish)
    }

    showSiTiaoAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playSiTiaoAnim(show, onFinish)
    }

    showZiMoWenZiAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playZiMoAnim(show, onFinish)
    }

    showFangPaoAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        seatHandCards.playJiePaoAnim(show, onFinish)
    }
    

    showJiePaoWenZiAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playJiePaoAnim(show, onFinish)
    }
    

    //结算飘分
    showSeatScore(localPos: number, show: boolean, score?: number, onFinish?: Function){
        let self = this
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let winNode = seatHandCards.nodeScoreWinAnim
        let loseNode = seatHandCards.nodeScoreLoseAnim
        winNode.active = (show && score >= 0)
        loseNode.active = show && score < 0        
        if(show){
            if(score >= 0){
                seatHandCards.labelWinScore.string = '+' + GameUtil.currencyFormat(score)
            }else{
                seatHandCards.labelLoseScore.string = GameUtil.currencyFormat(score) + ''
            }
            let node: cc.Node
            if(score >= 0){
                node = winNode
            }else{
                node = loseNode
            }
            let anim = cc.fadeIn(0.5)
            let callFun = cc.callFunc(function(){
                onFinish && onFinish()
            }.bind(self))
            node.opacity = 0
            node.runAction(cc.sequence([anim, callFun]))
        }
    }

    showSeatPiaoFen(localPos: number, show: boolean, score?: number, onFinish?: Function){
        let seatView = this.getSeatViewByPos(localPos) as BiPaiTableSeatView
        seatView.showPiaoFenAnim(show, score, onFinish)
    }

    showTongHuaShunAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playTongHuaShunAnim(show, onFinish)
    }

    showHuangJiaTongHuaShunAnim(localPos: number, show: boolean, onFinish?: Function){
        let seatHandCards = this.getSeatMingHandCards(localPos) as BiPaiSeatMingCards
        let hodler = seatHandCards.cardTypeAnimHolder
        hodler.playHuangJiaTongHuaShunAnim(show, onFinish)
    }

    playFlyBombAnim(localPos: number, fromLocalPos: number, onFinish?: Function){
        let fromBombView = this.seatBombViewList[fromLocalPos]
        let bombView = this.seatBombViewList[localPos]
        let fromWorldPos = fromBombView.node.convertToWorldSpaceAR(fromBombView.nodeFromPos.position)
        bombView.playBombFlyAnim(fromWorldPos, const_dir_map[fromLocalPos][localPos], onFinish)
    }

    playSeatBombAnim(localPos: number, delay?: number, onFinish?: Function){
        let bombView = this.seatBombViewList[localPos]
        bombView.playBombAnim(delay, onFinish)
    }

    playSeatGenPaiAnim(localPos: number, count: number, delay?: number, onFinish?: Function){
        let genPaiView = this.seatGenPaiViewList[localPos]
        genPaiView.playGenPaiAnim(count, delay, onFinish)
    }


    playFadeAnim(node: cc.Node, from: number, to: number, duration: number, delay: number, onFinish?: Function){
        node.opacity = from
        let tmp_fun = function(){            
            let callFun = cc.callFunc(function(){            
                onFinish && onFinish()
            }.bind(this))            
            let sequence = cc.sequence(cc.fadeTo(duration, to), callFun)
            node.runAction(sequence)
        }
        if(delay){
            this.scheduleOnce(function(){
                tmp_fun()
            }, delay)
        }else{
            tmp_fun()
        }
    }

    playFeiJiAnim(onFinish?: Function){
        let self = this
        self.nodeFeiJiAnim.active = true
        self.scheduleOnce(function(){
            self.nodeFeiJiAnim.active = false
            onFinish && onFinish()
        }, 1.05)
    }

    showPokerRecorder(show: boolean, showShort?: boolean, withOutDeal?: boolean){
        this.pokerRecorder.showRecord(show, showShort, withOutDeal)
    }

    refreshPokerRecorder(data){
        this.pokerRecorder.setData(data)
    }
}
